import { CompareDuplicatesPage } from '@/features/DuplicateCheck/CompareDuplicatesPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const compareDuplicatesSearchSchema = z.object({
    projectId: z.number().optional(),
    isAssetView: z.boolean().optional(),
    assetId: z.number().optional(),
});

export const Route = createFileRoute('/documents/duplicate-review/$id/')({
    component: CompareDuplicatesPage,
    validateSearch: compareDuplicatesSearchSchema,
});
